<template>
    <div  class="pedido">
        <h3>Pedido:</h3>
        <div v-for="(item, i) in json_pedido.pedido.itens" :key="item.id || i" class="item">
            <div class="item-header">
                <div>{{ item.quantidade }}x {{ item.nome }}</div>
                <div>R$ {{ item.precoTotal.toFixed(2) }}</div>
            </div>

            <!-- SUBITEM -->
            <div v-if="item.subitem" class="sub">

                <div>{{ item.subitem.nome }}</div>

                <!-- adicionais -->
                <div v-if="item.subitem.adicionar && item.subitem.adicionar.length">
                    <div  v-for="(add, a) in item.subitem.adicionar"  :key="a">
                        + {{ add.pergunta }} <span v-for="(op, o) in add.opcoesEscolhidas" :key="o">{{ op.nome }}</span>
                    </div>
                </div>

                <!-- retirar -->
                <div v-if="item.subitem.retirar && item.subitem.retirar.length">
                    <div v-for="(r, rI) in item.subitem.retirar" :key="rI">- {{ r.nome }}</div>
                </div>

                <!-- obs -->
                <div v-if="item.subitem.observacoes && item.subitem.observacoes.length">
                    {{ item.subitem.observacoes.join(', ') }}
                </div>

            </div>

            <!-- SUBITENS (objeto tipo pizza) -->
            <div v-if="item.subitens && item.subitens.sabores" class="sub">

                <div v-if="item.subitens.borda">
                    {{ item.subitens.borda.nome }}
                </div>

                <div v-if="item.subitens.massa">
                    {{ item.subitens.massa.nome }}
                </div>

                <div v-for="(sabor, s) in item.subitens.sabores" :key="s">
                    {{ sabor.nome }}

                    <div v-if="sabor.retirar && sabor.retirar.length">
                        <div v-for="(r, rI) in sabor.retirar" :key="rI">- {{ r.nome }}</div>
                    </div>

                    <div v-if="sabor.observacoes && sabor.observacoes.length">
                    {{ sabor.observacoes.join(', ') }}
                    </div>

                </div>
            </div>

            <!-- OBS ITEM -->
            <div v-if="item.observacoes && item.observacoes.length">
                {{ item.observacoes.join(', ') }}
            </div>

        </div>

    </div>   

</template>

<script>
/* eslint-disable */
export default {
    name: "BalcaoPedidoItens",

    props: {
        json_pedido: Object
    },

    data() {
        return {
            // json_pedido: null
        };
    },

    created() {
      
    },

    watch: {

    },

    computed: {
       
    },

    methods: {
        

    },

    components: {  }
}
</script>

<style scoped>
/* 🔹 CONFIG GLOBAL (edita só isso) */
.pedido {

  background: white;
  color: black;

  padding: 10px;
  margin: 16px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  border-radius: 6px;
  
  /* border: 1px solid white; */
}

.pedido h3 {
    font-size: 16px;
    color: black;
}

/* 🔹 CARD DO ITEM */
.item {
  background: rgb(236, 236, 236);
  /* border: 1px solid black; */
  border-radius: 14px;
  padding: 14px;
  margin-bottom: 12px;

  box-shadow: 0 2px 6px rgba(0,0,0,0.04);
}

/* 🔹 HEADER */
.item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  font-size: 12px;
  font-weight: 600;
}

.item-header div:last-child {
  font-weight: 700;
}

/* 🔹 SUB ÁREAS */
.sub,
.sabor {
  margin-top: 8px;
  margin-left: 10px;
  font-size: 10px;

}

.sub, .sabor{
    align-items: start;
    justify-content: start;
    /* background-color: red; */
    text-align: start;
}


</style>


